import { SlTitledListComponent } from '@varo/graphql-schema-types';
import LoanItems from 'features/payOverTime/components/LoanItems/LoanItems';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import Illustration from 'shared/components/vxl/Illustration/Illustration';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import theme from 'shared/styles/theme';

export interface CurrentLoansTabProps {
  openLoans?: SlTitledListComponent[];
}

const CurrentLoansTab = ({ openLoans }: CurrentLoansTabProps) => {
  const { t: translatedText } = useTranslation('payOverTime', {
    keyPrefix: 'manageLoans',
  });

  if (openLoans?.length && openLoans.length > 0) {
    return (
      <ScrollView style={styles.screen}>
        <LoanItems openLoans={openLoans} />
      </ScrollView>
    );
  }

  return (
    <ScrollView style={styles.screen}>
      <View style={styles.emptyStateContainer}>
        <View style={styles.image}>
          <Illustration illustration="COINS_C" />
        </View>
        <BodyBaseText style={styles.emptyText}>
          {translatedText('emptyHistory')}
        </BodyBaseText>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  emptyStateContainer: {
    alignItems: 'center',
    flex: 1,
  },
  emptyText: {
    color: theme.color.text.secondary,
  },
  image: {
    height: 131,
    width: 131,
  },
  screen: {
    flex: 1,
  },
});

export default CurrentLoansTab;
